// @flow
import * as dbTracker from './dbTracker';
import * as clarityTracker from './clarityTracker';
import * as gtmTracker from './gtmTracker';
import * as openaiAdsTracker from './openaiAdsTracker';
import { TRACKING_EVENTS } from './events';
import { sanitizeTrackingProperties } from './privacy';

export { TRACKING_EVENTS };

type User = {
  id: string,
  [key: string]: any,
};

type EventProperties = {
  productId?: string,
  productSlug?: string,
  productTitle?: string,
  productPriceId?: string,
  brand?: string,
  supplierUsername?: string,
  quantity?: number,
  [key: string]: any,
};

export const identifyUser = (user: User): void => {
  gtmTracker.setUser(user);
  clarityTracker.identify(user);
  openaiAdsTracker.identify(user);
};

export const track = async (
  eventName: string,
  properties: EventProperties = {},
): Promise<void> => {
  const safeProperties = sanitizeTrackingProperties(properties);
  gtmTracker.push(eventName, safeProperties);
  clarityTracker.trackEvent(eventName, safeProperties);
  openaiAdsTracker.track(eventName, safeProperties);

  // 로그인/비로그인 모두 발송한다. dbTracker가 비로그인 시 anonymous_id로 저장하고,
  // sendBeacon/keepalive로 네비게이션 중 손실을 방지한다.
  dbTracker.send(eventName, safeProperties);
};

export const trackPageView = async (
  location?: { pathname: string, search: string },
): Promise<void> => {
  gtmTracker.pushPageView(location);
  clarityTracker.trackEvent('page_viewed', {});
  openaiAdsTracker.track(TRACKING_EVENTS.PAGE_VIEWED, {});

  dbTracker.send('page_viewed', {});
};

export const resetSession = (): void => {
  gtmTracker.resetUser();
  dbTracker.reset();
  clarityTracker.reset();
};

export const setTag = (key: string, value: string): void => {
  clarityTracker.setTag(key, value);
};

export const upgradeSession = (reason: string): void => {
  clarityTracker.upgrade(reason);
};



// WEBPACK FOOTER //
// ./src/lib/tracking/index.js